import type { ReactElement } from "react";
import { Box, useMediaQuery } from "@mui/material";
import type { Theme } from "@mui/material";
import { DatagridConfigurable, useListContext } from "react-admin";
import { Column } from "../misc/Column";
import { LoadingIndicator } from "../misc/LoadingIndicator";
import type { PerformanceOverviewRecord } from "../providers/performanceOverviewProvider";
import { PerformanceOverviewMobileListItem } from "./PerformanceOverviewMobileListItem";

export function PerformanceOverviewDataGrid(props: {
  columns: ReactElement[];
  empty: ReactElement;
  omit: string[];
  onRecordClick: (record: PerformanceOverviewRecord) => void;
  preferenceKey: string;
}) {
  const { columns, empty, omit, onRecordClick, preferenceKey } = props;
  const { data, isLoading, total } = useListContext<PerformanceOverviewRecord>();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  if (isMobile) {
    if (isLoading) {
      return <LoadingIndicator />;
    }
    if (!data || data.length === 0 || total === 0) {
      return empty;
    }
    return (
      <Column sx={{ gap: 1, py: "1px" }}>
        {data.map((record) => (
          <PerformanceOverviewMobileListItem key={record.id} record={record} onClick={() => onRecordClick(record)} />
        ))}
      </Column>
    );
  }

  return (
    <Box data-testid="PerformanceOverviewTableScroll" sx={{ maxWidth: "100%", minWidth: 0, overflowX: "auto" }}>
      <DatagridConfigurable
        preferenceKey={preferenceKey}
        omit={omit}
        rowClick={(_, __, record) => {
          onRecordClick(record as PerformanceOverviewRecord);
          return false;
        }}
        bulkActionButtons={false}
      >
        {columns}
      </DatagridConfigurable>
    </Box>
  );
}
